import { atom } from "jotai";


const syncFormKeyAtom = atom<string>("");

export default syncFormKeyAtom;
